import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import DetailsList from '../DetailsList';
import styles from './BundlesList.style';

const baseColumns = [
  {
    key: 'icon',
    name: 'icon',
    headerClassName: styles.iconColumnHeader,
    iconClassName: styles.headerIcon,
    arianame: 'icon',
    iconName: 'CubeShape',
    isIconOnly: true,
    fieldName: 'icon',
    minWidth: 8,
    maxWidth: 8,
    columnActionsMode: 0,
    onRender: () => {
      return (
        <div className={styles.iconColumn}>
          <FontIcon iconName="LocationDot" arianame="LocationDot" />
        </div>
      );
    },
  },
  {
    key: 'name',
    name: 'Bundle Name',
    fieldName: 'bundleName',
    isResizable: false,
    minWidth: 100,
    maxWidth: 330,
  },
];

const BundlesList = ({ items, totalRecords, className: classNameProp, disabled, ...other }) => {
  const className = clsx(classNameProp);
  const { columns } = { ...other };
  const [listItems, setListItems] = useState([]);

  useEffect(() => {
    if (items.length < totalRecords) {
      const data = [...items];
      data.push(null);
      setListItems(data);
    } else {
      setListItems(items);
    }
  }, [items]);

  return (
    <>
      <DetailsList
        items={listItems.map(
          item =>
            item && {
              ...item,
              key: item._id,
              link: `/bundles/${item.bundleId}`,
            },
        )}
        columns={columns ? baseColumns : columns}
        className={className}
        {...other}
      />
    </>
  );
};

BundlesList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      bundleId: PropTypes.string,
      bundleName: PropTypes.string,
      createdBy: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  totalRecords: PropTypes.number,
};

BundlesList.defaultProps = {
  items: [],
  className: '',
  disabled: false,
  totalRecords: 0,
};

export default BundlesList;
